import React, { useEffect, useState } from 'react';
import { Box, Typography, Dialog, IconButton, Grid, Divider } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { makeStyles } from '@mui/styles';
import { validateDigit } from '../../../utils/validation';
import CustomButton from '../../UI/CustomButton';
import CustomInput from '../../UI/CustomInput';
import { setSnackbar } from '../../../store/common/common.reducer';
import { useDispatch } from 'react-redux';
import { TJobOffer } from '../../../types/JobOffer';
import { addJobOffer, updateJobOffer } from '../../../apis/job';
import './add.scss';

const useStyles = makeStyles(() => ({
  paper: {
    direction: 'rtl',
    borderRadius: '1rem !important',
  },
}));

interface ConfirmStartTestProps {
  openAddUserDialog: boolean;
  closeDialog: () => void;
  getJobOfferData: () => void;
  selectJobOffer: TJobOffer;
}

const AddJobOfferDialog: React.FC<ConfirmStartTestProps> = (props) => {
  const { openAddUserDialog, closeDialog, selectJobOffer, getJobOfferData } = props;
  const styles = useStyles();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');

  const clearAllState = () => {
    setTitle('');
    setDescription('');
  };

  const onCloseAndResetDialog = () => {
    clearAllState();
    closeDialog();
  };

  useEffect(() => {
    if (selectJobOffer && openAddUserDialog) {
      const { title = '', description } = selectJobOffer;
      setTitle(title);
      setDescription(description);
    }
  }, [selectJobOffer, openAddUserDialog]);

  const onSubmit = () => {
    setLoading(true);

    if (selectJobOffer) {
      const { id } = selectJobOffer || {};
      updateJobOffer(id, title, description)
        .then(() => {
          getJobOfferData();
          closeDialog();
          dispatch(
            setSnackbar({ openSnackbar: true, message: 'فرصت شفلی با موفقیت ویرایش گردید' }),
          );
        })
        .catch((e) => console.log({ e }))
        .finally(() => {
          setLoading(false);
          onCloseAndResetDialog();
        });
    } else {
      addJobOffer(title, description)
        .then(() => {
          getJobOfferData();
          closeDialog();
          dispatch(setSnackbar({ openSnackbar: true, message: 'فرصت شفلی با موفقیت اضافه گردید' }));
        })
        .catch((e) => console.log({ e }))
        .finally(() => setLoading(false));
    }
  };

  const disabled = !title || !description;

  return (
    <Dialog
      onClose={onCloseAndResetDialog}
      open={openAddUserDialog}
      maxWidth='xl'
      classes={{ paper: styles.paper }}
    >
      <Box className='mainDialog'>
        <Box className='header'>
          <Typography color='text.main' fontWeight='bold'>
            افزودن فرصت شغلی
          </Typography>
          <IconButton onClick={onCloseAndResetDialog}>
            <CloseRoundedIcon color='action' />
          </IconButton>
        </Box>

        <Grid container>
          <Grid item lg={12} xs={12}>
            <CustomInput
              label={title ? 'عنوان' : ''}
              placeholder='عنوان'
              value={title}
              onChangeHandler={(value) => {
                const ignore = validateDigit(value);
                if (ignore) setTitle(value);
              }}
            />
          </Grid>

          <Grid item lg={12} md={6} xs={12}>
            <CustomInput
              label={description ? 'توضیحات' : ''}
              placeholder='توضیحات'
              multiline
              rows={4}
              value={description}
              onChangeHandler={(value) => {
                const ignore = validateDigit(value);
                if (ignore) setDescription(value);
              }}
            />
          </Grid>
        </Grid>

        <Box className='flexCenter' gap={1}>
          <CustomButton fullWidth variant='outlined' onClick={onCloseAndResetDialog}>
            <Box className='flexCenter' px={2}>
              <Typography>انصراف</Typography>
            </Box>
          </CustomButton>
          <CustomButton
            fullWidth
            disabled={disabled || loading}
            loading={loading}
            onClick={onSubmit}
          >
            <Typography px={2}>{selectJobOffer ? 'ویرایش' : 'تایید'}</Typography>
          </CustomButton>
        </Box>

        <Divider sx={{ marginTop: 2 }} />
      </Box>
    </Dialog>
  );
};

export default AddJobOfferDialog;
